import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';
import { exportConstants } from './support';
import FormWrapper from '../../Reusable/FormWrapper/FormWrapper.js';

const ExportDataForm = (props) => {
  const {
    typeOfExport,
    errors,
    setErrors,
    onChangeComboBoxHandler,
    onSubmitHandler,
    typeOfExportPlaceholder,
    submitRef,
  } = props || {};

  return (
    <FormWrapper submitRef={submitRef} onClick={onSubmitHandler}>
      <Row>
        <Col md={8} className="m-auto">
          <ComboBoxAutocomplete
            id="typeOfExport"
            data={exportConstants}
            textExtractor={(a) => a}
            changeValue={(newValue) => onChangeComboBoxHandler(newValue)}
            label={typeOfExportPlaceholder}
            updateValue={typeOfExport}
            error={errors}
            errorsHandler={setErrors}
          />
        </Col>
      </Row>
    </FormWrapper>
  );
};

export default ExportDataForm;
